import { Box, Tooltip, Typography } from "@mui/material";

interface VsNumbersProps {
  percentageDelta: number | null | undefined;
  absoluteDelta: number | null | undefined;
  precision?: number;
  showTooltip?: boolean;
}

const getColorForDelta = (delta: number | null | undefined): string => {
  if (delta === null || delta === undefined) {
    return "text.secondary";
  }

  if (delta > 0) {
    return "success.main";
  }

  if (delta < 0) {
    return "error.main";
  }

  return "text.secondary";
};

const VsNumbers = ({
  percentageDelta,
  absoluteDelta,
  precision = 1,
  showTooltip = true
}: VsNumbersProps) => {
  const formattedPercentage = percentageDelta !== null && percentageDelta !== undefined
    ? `${percentageDelta >= 0 ? "+" : ""}${percentageDelta.toFixed(precision)}%`
    : "N/A";

  const formattedAbsolute = absoluteDelta !== null && absoluteDelta !== undefined
    ? `${absoluteDelta >= 0 ? "+" : ""}${absoluteDelta.toFixed(2)}`
    : "N/A";

  const color = getColorForDelta(percentageDelta);

  const content = (
    <Box sx={{ display: "inline-flex", alignItems: "baseline", gap: 0.5 }}>
      <Typography
        variant="body2"
        component="span"
        sx={{ color, fontWeight: 500 }}
      >
        {formattedPercentage}
      </Typography>
      <Typography
        variant="caption"
        component="span"
        sx={{ color: "text.secondary", fontSize: "0.7rem" }}
      >
        ({formattedAbsolute})
      </Typography>
    </Box>
  );

  if (showTooltip && absoluteDelta !== null && absoluteDelta !== undefined) {
    return (
      <Tooltip
        title={`Value difference: ${formattedAbsolute}`}
        arrow
        placement="top"
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};

export default VsNumbers;
